import view from './view'
export {view}


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/question_view/index.js